import React, { useEffect, useState, useMemo } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiArrowDownLeft, FiArrowUpRight, FiPhoneCall, FiPhoneMissed, FiPhoneOff, FiSearch, FiLogOut, FiInbox } from "react-icons/fi";
import { callbacks, dialKeys } from "../ctiData";
import { formatSeconds, toneStyle } from "../ctiHelpers";
import { FaPause, FaMicrophone, FaPhone } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { postApiCall, getApiCall } from '../../../service/httpCall';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { FiInfo } from "react-icons/fi";
import { FaCheck, FaTimes, FaChevronLeft , FaChevronRight } from "react-icons/fa";
import { useCallStore } from "../../../router/zustand/callStore";
import audio1 from "../../../assets/dtmf_tones/1.wav";
import audio2 from "../../../assets/dtmf_tones/2.wav";
import audio3 from "../../../assets/dtmf_tones/3.wav";
import audio4 from "../../../assets/dtmf_tones/4.wav";
import audio5 from "../../../assets/dtmf_tones/5.wav";
import audio6 from "../../../assets/dtmf_tones/6.wav";
import audio7 from "../../../assets/dtmf_tones/7.wav";
import audio8 from "../../../assets/dtmf_tones/8.wav";
import audio9 from "../../../assets/dtmf_tones/9.wav";
import hash from "../../../assets/dtmf_tones/hash.wav";
import star from "../../../assets/dtmf_tones/star.wav";
import audio0 from "../../../assets/dtmf_tones/zero0.wav";
import { API_AGENT_SCHEDULE, CALL_GROUP_REMOVE_AGENT } from '../../../service/url';
import { toast } from "react-toastify";

const toneMap = {
  "1": audio1,
  "2": audio2,
  "3": audio3,
  "4": audio4,
  "5": audio5,
  "6": audio6,
  "7": audio7,
  "8": audio8,
  "9": audio9,
  "0": audio0,
  "*": star,
  "#": hash,
};


const CAMPAIGN_STATUS_MAP = {
  Ready: 0,
  Running: 1,
  Complete: 2,
  "Low Balance": 3,
  Error: 4,
  "Critical Error": 5,
  Cancelling: 6,
  Cancelled: 7,
  Pausing: 8,
  Paused: 9,
  Resuming: 10,
  "DND Processing": 21,
  "Waiting for Channel": 22,
};

const STATUS_LABEL_MAP = Object.fromEntries(
  Object.entries(CAMPAIGN_STATUS_MAP).map(([key, value]) => [value, key])
);

const getStatusUI = (status) => {
  switch (status) {
    case "Running":
      return { badgeClass: "green", color: "#22c55e" };

    case "Ready":
      return { badgeClass: "green", color: "#22c55e" };
    case "Paused":
      return { badgeClass: "gray", color: "#9ca3af" };

    case "Complete":
      return { badgeClass: "blue", color: "#3b82f6" };

    case "Low Balance":
    case "Error":
    case "Critical Error":
      return { badgeClass: "red", color: "#ef4444" };

    case "Cancelling":
    case "Paused":
    case "Pausing":
    case "Resuming":
      return { badgeClass: "amber", color: "#f59e0b" };

    default:
      return { badgeClass: "gray", color: "#6b7280" };
  }
};

function DeleteGlyph() {
  return <span className="delete-fallback">⌫</span>;
}

function IdleScreen({
  idleSeconds,
  idleStatus,
  activeTab,
  dialNum,
  breakEndTime,
  countdown,
  breaksData,
  selectedBreakId,
  onDial,
  onDialBack,
  onTabChange,
  onStatusChange,
  onPlaceCall,
  onSetBreakClick,
  onRemoveBreakClick,
  theme,
  userStatus,
  campaigns,
  agentCallsData,
  loggedUserId,
  loggedUserRole,
  onRinging,
  announcements,
  userData,
  onCallLogFilter,
}) {
  const idleStatusLabel = userStatus === "BREAK" ? "ON BREAK" : idleStatus;
  // const [webrtcStatus, setWebrtcStatus] = useState(null);
  const [activeAgents, setActiveAgents] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [agentGroups, setAgentGroups] = useState([]);
  const [queuePage, setQueuePage] = useState(0);
  const [agentSchedule, setAgentSchedule] = useState({})
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [showExitModal, setShowExitModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [removeGroupLoading, setRemoveGroupLoading] = useState(false);
  
  const pageSize = 2;
  const totalPages = Math.ceil(agentGroups.length / pageSize);
  const todayStats = useMemo(
    () => agentCallsData?.todayCallStats || {},
    [agentCallsData]
  );
  const callRecords = useMemo(
    () => agentCallsData?.callRecords || [],
    [agentCallsData]
  );

  const [callLogStartDate, setCallLogStartDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  const [callLogEndDate, setCallLogEndDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );

  const callLogMinDate = useMemo(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d.toISOString().split("T")[0];
  }, []);

  const callLogMaxDate = useMemo(() => new Date().toISOString().split("T")[0], []);

  const handleCallLogStartDate = (e) => {
    const val = e.target.value;
    setCallLogStartDate(val);
    const end = val > callLogEndDate ? val : callLogEndDate;
    if (val > callLogEndDate) setCallLogEndDate(val);
    onCallLogFilter?.(val, end);
  };

  const handleCallLogEndDate = (e) => {
    const val = e.target.value;
    setCallLogEndDate(val);
    onCallLogFilter?.(callLogStartDate, val);
  };


  const handleDialerCall = () => {
    if (!(dialNum && parsedStatus?.success)) {
      return;
    }

    onPlaceCall();
  };

  const handleAgentCall = (agentNumber) => {
    if (!parsedStatus?.success) {
      return;
    }

    onRinging(agentNumber);
  };

  const playTone = (digit) => {
    try {
    const toneFile = toneMap[digit];
    if (!toneFile) return;

    const audio = new Audio(toneFile);
    audio.currentTime = 0;
    audio.play().catch((err) => {
      console.log("Audio play blocked:", err);
    });
    } catch (err) {
      console.log("Error playing tone:", err);
    }
  };

  useEffect(() => {
    const activeCount = agentCallsData?.agentsData?.filter(
      (agent) => agent.status === "active"
    )?.length;
    setActiveAgents(activeCount || 0);
  }, [agentCallsData]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const status = sessionStorage.getItem("webrtcPhoneStatus");
  //     setWebrtcStatus(status);
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  const fetchAgentGroups = async () => {
    try {
      const resp = await getApiCall(
        `${API_AGENT_SCHEDULE}/${loggedInUserDetail?.agentData?.id}`
      );

      setAgentGroups(resp?.groups || []);
      setAgentSchedule(resp?.scheduleData || {});
    } catch (err) {
      console.log(err);
      toast.error(err ? JSON.stringify(err) : "Failed to fetch agent groups.");
      setAgentGroups([]);
    }
  };

  useEffect(() => {
    if (!loggedInUserDetail?.agentData?.id) return;
    fetchAgentGroups();
  }, [loggedInUserDetail?.agentData?.id]);

    useEffect(() => {
      const fetchUserData = async () => {
            const rawUser = await AsyncStorage.getItem('user');
          
            if (!rawUser) {
              console.error("User data not found in AsyncStorage");
              return;
            }
          
            let user;
            try {
              user = JSON.parse(rawUser);
            } catch (e) {
              console.error("Invalid JSON in AsyncStorage user:", e);
              return;
            }

            setLoggedInUserDetail(user)
      }
      fetchUserData();
    }, []);

  const webrtcStatus = useCallStore((state) => state.webrtcPhoneStatus);
  const webrtcPhoneStartTime = useCallStore((state) => state.webrtcPhoneStartTime);
  const callState = useCallStore((state) => state.callState);
  const idleSessionStartedAt = useCallStore((state) => state.idleSessionStartedAt);
  const setIdleSessionStartedAt = useCallStore((state) => state.setIdleSessionStartedAt);
  const isOnCall =
    callState === "oncall" ||
    callState === "connected" ||
    callState === "hold" ||
    callState === "conference";
  const isBusyForBreak = isOnCall || callState === "incoming";

  const parsedStatus = useMemo(() => {
    if (!webrtcStatus) {
      return {
        success: false,
        code: "DISCONNECTED",
        message: "Dialer is Disconnected",
      };
    }

    const status = webrtcStatus.toLowerCase();

    // ✅ SUCCESS CASE (only 200 / connected)
    if (status === "connected") {
      return {
        success: true,
        code: "READY",
        message: "Dialer connected",
      };
    }

    // ✅ AUTHENTICATING (401 first case)
    if (status.includes("authenticating")) {
      return {
        success: false,
        code: "AUTH",
        message: "Authenticating...",
      };
    }

    // ✅ GENERIC "code - message" fallback
    const match = webrtcStatus.match(/^(\d+)\s*-\s*(.*)$/);

    if (match) {
      return {
        success: false,
        code: match[1],
        message: match[2],
      };
    }

    // ✅ FALLBACK (plain message)
    return {
      success: false,
      code: "ERROR",
      message: webrtcStatus,
    };
  }, [webrtcStatus]);

  useEffect(() => {
    if (!parsedStatus?.success) return;
    if (callState !== "idle") return;
    if (userStatus === "BREAK") return;
    if (idleSessionStartedAt) return;

    setIdleSessionStartedAt(webrtcPhoneStartTime || new Date().toISOString());
  }, [
    parsedStatus,
    callState,
    userStatus,
    idleSessionStartedAt,
    webrtcPhoneStartTime,
    setIdleSessionStartedAt,
  ]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {parsedStatus ? parsedStatus?.message : null}
    </Tooltip>
  );

  const [breakRemaining, setBreakRemaining] = useState(null);

  useEffect(() => {
    if (!breakEndTime) return;

    const timer = setInterval(() => {
      const remaining = Math.floor((breakEndTime - Date.now()) / 1000);

      if (remaining <= 0) {
        setBreakRemaining(0);
        clearInterval(timer);
      } else {
        setBreakRemaining(remaining);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [breakEndTime]);

  const activeBreak = useMemo(() => {
    return breaksData?.find((b) => b.id == selectedBreakId);
  }, [breaksData, selectedBreakId]);

  const formattedAnnouncements = useMemo(() => {
    const list = Array.isArray(announcements) ? announcements : [];
    return list
      .filter((a) => a?.heading || a?.content)
      .map((a) => ({
        id: a?.id || `${a?.heading}-${a?.created_at}`,
        heading: a?.heading || "Announcement",
        content: a?.content || "",
        createdAt: a?.created_at || null,
      }));
  }, [announcements]);

  const formatAnnouncementDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString();
  };

  const connectedRate = useMemo(() => {
    const totalCalls = Number(todayStats?.total_calls_today) || 0;
    const totalConnected = Number(todayStats?.total_connected_calls) || 0;

    if (!totalCalls) {
      return 0;
    }

    return Math.round((totalConnected / totalCalls) * 100);
  }, [todayStats]);

  const talkTimeProgress = useMemo(() => {
    const totalTalkTime = Number(todayStats?.total_talk_time) || 0;
    return Math.min(Math.round((totalTalkTime / 28800) * 100), 100);
  }, [todayStats]);

  const avgHandleProgress = useMemo(() => {
    const avgHandleTime = Number(todayStats?.avg_handle_time) || 0;
    return Math.min(Math.round((avgHandleTime / 600) * 100), 100);
  }, [todayStats]);

  const performanceBlocks = useMemo(
    () => [
      {
        label: "Talk Time",
        value: formatSeconds(Number(todayStats?.total_talk_time) || 0),
        color: "var(--green)",
        width: `${talkTimeProgress}%`,
      },
      {
        label: "Connected Rate",
        value: `${connectedRate}%`,
        color: "var(--amber)",
        width: `${connectedRate}%`,
      },
      {
        label: "Avg Handle Time",
        value: formatSeconds(Number(todayStats?.avg_handle_time) || 0),
        color: "var(--blue)",
        width: `${avgHandleProgress}%`,
      },
    ],
    [avgHandleProgress, connectedRate, talkTimeProgress, todayStats]
  );

  const formatCallLogTimestamp = (value) => {
    if (!value) return "--:--";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "--:--";

    const now = new Date();
    const isToday =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

    const time = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });

    if (isToday) return `Today - ${time}`;

    const dateParts = new Intl.DateTimeFormat("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).formatToParts(date);

    const getPart = (type) => dateParts.find((p) => p.type === type)?.value || "";
    const day = getPart("day");
    const month = getPart("month");
    const year = getPart("year");

    return `${day} ${month}, ${year} - ${time}`.trim();
  };

  const formattedCallLogs = useMemo(() => {
    return callRecords.map((record) => {
      const isIncoming = record?.direction === "incoming";
      const answerStatus =
        record?.answer_status || (record?.answered ? "answered" : "not_answered");
      const isAnswered = answerStatus === "answered" || Boolean(record?.answered);
      const hangupCause = String(record?.hangup_cause || "").toLowerCase();
      const declinedByAgent =
        hangupCause.includes("declined_by_agent") || hangupCause.includes("declined");
      const callTime = record?.time_of_call || record?.created_at;
      const formattedTime = formatCallLogTimestamp(callTime);

      return {
        id: record?.id,
        icon: isAnswered
          ? isIncoming
            ? <FiArrowDownLeft />
            : <FiArrowUpRight />
          : isIncoming
            ? declinedByAgent
              ? <FiPhoneOff />
              : <FiPhoneMissed />
            : <FiPhoneOff />,
        color: isAnswered ? (isIncoming ? "var(--green)" : "var(--blue)") : "var(--red)",
        name: record?.name || record?.caller_profile || "Unknown",
        num: record?.number || record?.caller_number || record?.callee_number || "-",
        dur: isAnswered
          ? formatSeconds(Number(record?.billing_duration) || 0)
          : isIncoming
            ? declinedByAgent
              ? "Declined"
              : "Missed"
            : "Declined",
        time: formattedTime,
        danger: !isAnswered,
      };
    });
  }, [callRecords]);

  const mappedCampaigns = useMemo(() => {
  if (!campaigns) return [];

  return campaigns.map((c) => {
    const statusLabel =
      STATUS_LABEL_MAP[Number(c.campaign_status)] || "Unknown";

    const ui = getStatusUI(statusLabel);

    return {
      name: c.campaign_name,
      meta: `${c.start_date} → ${c.end_date} • ${c.total_nos} leads`,
      badge: statusLabel,
      badgeClass: ui.badgeClass,
      color: ui.color,
      status: statusLabel,
    };
  });
}, [campaigns]);

const liveCount = mappedCampaigns.filter(
  (c) => (c.badge === "Running" || c.badge === "Ready")
).length;

const filteredAgents = agentCallsData?.agentsData
  ?.filter((item) => item.agent?.id != Number(loggedUserId))
  ?.filter((item) => {
    const name = item.agent?.agent_name?.toLowerCase() || "";
    const number = item.agent?.agent_number?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();

    return name.includes(search) || number.includes(search);
  })
  ?.sort((a, b) => {
    if (a.status === "active" && b.status !== "active") return -1;
    if (a.status !== "active" && b.status === "active") return 1;
    return 0;
  });

    const isInSchedule = (schedule) => {

      if (!schedule || Object.keys(schedule).length === 0) return false;

      const now = new Date();
      const currentDay = now.toLocaleString("en-US", { weekday: "long" });
      const currentMinutes = now.getHours() * 60 + now.getMinutes();

      const [startH, startM] = schedule.start_time.split(":").map(Number);
      const [endH, endM] = schedule.end_time.split(":").map(Number);

      const startMinutes = startH * 60 + startM;
      const endMinutes = endH * 60 + endM;

      const isDayValid = schedule.week_days?.includes(currentDay);

      const isTimeValid =
        startMinutes <= endMinutes
          ? currentMinutes >= startMinutes && currentMinutes <= endMinutes
          : currentMinutes >= startMinutes || currentMinutes <= endMinutes;

      return isDayValid && isTimeValid;
    };

    const sortedGroups = [...agentGroups].sort((a, b) => {
      const aActive = isInSchedule(a.group_schedule);
      const bActive = isInSchedule(b.group_schedule);

      return bActive - aActive;
    });

    const paginatedGroups = sortedGroups.slice(
      queuePage * pageSize,
      queuePage * pageSize + pageSize
    );

    const hasPrev = queuePage > 0;
    const hasNext = queuePage < totalPages - 1;

    const formatTime = (time) => {
      if (!time) return false;

      let [h, m] = time.split(":");
      h = Number(h);
      const ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;
      return `${h}:${m} ${ampm}`;
    };

  const handleExitClick = (grp) => {
    setSelectedGroup(grp);
    setShowExitModal(true);
  };

  const handleConfirmExit = async () => {
    setRemoveGroupLoading(true);
    try {
      postApiCall(`${CALL_GROUP_REMOVE_AGENT}/${selectedGroup.group_id}`, { agent_id: userData?.agentData?.id }).then(() => {
        toast.success("Successfully exited the group.");
        setShowExitModal(false);
        setSelectedGroup(null);
      });
      fetchAgentGroups();
    } catch (err) {
      console.error("Exit failed", err);
      toast.error(err ? JSON.stringify(err) : "Failed to exit the group.");
    } finally {
      setRemoveGroupLoading(false);
    }
  };


  return (
    <>
    <div className="screen active">
      <div className="idle-grid">
        <div className="stack-col">
          <div className="panel" style={{marginRight: '5px'}}>
            <div className="panel-header">
              <span className="panel-title">Today's Stats</span>
            </div>
            <div className="panel-body">
              <div className="idle-timer-box">
                <div className="idle-timer-label">Idle Duration</div>
                <div className="idle-timer-value">
                  {parsedStatus?.success
                    ? isBusyForBreak
                      ? "00:00:00"
                      : formatSeconds(idleSeconds)
                    : "-- --"}
                </div>
                <div className="idle-timer-sub">Since last call ended</div>
              </div>
              <div className="stats-row">
                <div className="stat-box">
                  <div className="stat-label">Calls Today</div>
                  <div className="stat-value">
                    {Number(todayStats?.total_calls_today) || 0}
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-label">Talk Time</div>
                  <div className="stat-value amber">
                    {formatSeconds(Number(todayStats?.total_talk_time) || 0)}
                  </div>
                </div>
              </div>
              <div className="stats-row">
                <div className="stat-box">
                  <div className="stat-label">Connected</div>
                  <div className="stat-value green">
                    {Number(todayStats?.total_connected_calls) || 0}
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-label">Avg Handle</div>
                  <div className="stat-value">
                    {formatSeconds(Number(todayStats?.avg_handle_time) || 0)}
                  </div>
                </div>
              </div>
              <div className="status-action-row">
                {userStatus !== "BREAK" && (
                  <Button
                    className="status-action amber-btn"
                    onClick={onSetBreakClick}
                    disabled={isBusyForBreak}
                    style={{ opacity: isBusyForBreak ? "0.4" : "1" }}
                  >
                    SET BREAK
                  </Button>
                )}

                {userStatus === "BREAK" && (
                  <div
                    style={{
                      width: "100%",
                      // padding: "12px",
                      // background: "#ffffff",
                      borderRadius: "8px",
                      // border: "1px solid #8f8f8f",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      className="status-action red-btn"
                      style={{ width: "100%", padding: "10px" }}
                      onClick={onRemoveBreakClick}
                    >
                      REMOVE BREAK
                    </Button>
                  </div>
                )}
                {(isBusyForBreak && userStatus !== 'BREAK') && (
                  <div className="status-helper-text">
                   You can’t set break while on call / ringing / hold / conference.
                  </div>
                )}
                {(isBusyForBreak && userStatus === 'BREAK') && (
                  <div className="status-helper-text">
                    Agent can log in to take calls after ending the break.
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="panel fill-panel" style={{marginRight: '5px', height: "350px", maxHeight: "350px", overflowY: "scroll"}}>
            <div className="panel-header">
              <span className="panel-title">Active Campaigns</span>
              <span className="mono-green">{liveCount || 0}</span>
            </div>
            <div className="panel-body">
              {mappedCampaigns.map((campaign, index) => (
                <div className="campaign-item" key={index}>
                  <div
                    className="campaign-dot"
                    style={{ background: campaign.color }}
                  />
                  <div className="flex-1">
                    <div className="campaign-name">{campaign.name}</div>
                    <div className="campaign-meta">{campaign.meta}</div>
                </div>
                {/* <p className={`campaign-dot ${campaign.badgeClass}`} style={{ marginLeft: "12px" }}>
                  Status: {campaign.status}
                </p> */}
              </div>
            ))}
              <div className="queue-card">
                <div className="queue-title">Queue Status</div>
                {/* <div className="queue-row">
                  <span className="queue-amber">Waiting:</span>
                  <span className="queue-amber">0 calls</span>
                </div> */}
                <div className="queue-row">
                  <span className="queue-amber">Agents Online:</span>
                  <span className="queue-green">{activeAgents} / {Number(agentCallsData?.agentsData?.length) || 1}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="stack-col" style = {{marginLeft : '5px'}}>
          <div className="panel" style={{ height: "250px", overflowY: "scroll" }}>
            <div
              className="panel-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                // marginBottom: 6,
                borderBottom: "1px solid rgba(0,0,0,0.08)",
                // paddingBottom: 4,
              }}
            >
              <div className="panel-title">Assigned Groups({agentGroups.length})</div>

              {agentGroups.length > pageSize && (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setQueuePage((p) => Math.max(0, p - 1));
                    }}
                    disabled={!hasPrev}
                    className="panel-title"
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: hasPrev ? "pointer" : "not-allowed",
                      opacity: hasPrev ? 1 : 0.3,
                      color: hasPrev ? "#000" : "#999",
                    }}
                  >
                    <FaChevronLeft />
                  </button>

                  <span className="panel-title">
                    {queuePage + 1}/{totalPages}
                  </span>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setQueuePage((p) =>
                        Math.min(totalPages - 1, p + 1)
                      );
                    }}
                    disabled={!hasNext}
                    className="panel-title"
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: hasNext ? "pointer" : "not-allowed",
                      opacity: hasNext ? 1 : 0.3,
                      color: hasNext ? "#000" : "#999",
                    }}
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}

              {agentGroups.length == 0 && (
                <div
                  style={{
                    color: "rgb(239, 5, 5)",
                    display: "inline-block",
                    animation: "zoomPulse 2s ease-in-out infinite",
                    fontSize: "13px",
                  }}
                >
                  No Group Assigned

                  <style>
                    {`
                      @keyframes zoomPulse {
                        0% {
                          transform: scale(1);
                        }
                        50% {
                          transform: scale(1.05);
                        }
                        100% {
                          transform: scale(1);
                        }
                      }
                    `}
                  </style>
                </div>
              )}

            </div>

            {agentGroups?.length === 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "200px",
                  opacity: 0.4,
                  flexDirection: "column",
                }}
              >
                <FiInbox size={40} />
                <div style={{ fontSize: "0.8rem", marginTop: "6px" }}>
                  No Groups Assigned
                </div>
              </div>
            )}

            {paginatedGroups.map((grp, idx) => {
              const hasGroupSchedule = !!grp.group_schedule;
              const hasAgentSchedule = !!grp.schedule;

              const isGroupActive =
                hasGroupSchedule && isInSchedule(grp.group_schedule);
              const isAgentActive =
                hasAgentSchedule && isInSchedule(grp.schedule);

              return (
                <div
                  key={idx}
                  style={{
                    padding: "10px",
                    // marginBottom: "10px",
                    // borderRadius: "10px",
                    // border: "1px solid #eee",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                  >
                    <div
                      className="stat-value"
                      style={{ fontWeight: 800, fontSize: "0.8rem" }}
                    >
                      {grp.group_name}
                    </div>

                    <div style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px"
                    }}>
                    <div
                      style={{
                        fontSize: "0.7rem",
                        padding: "3px 8px",
                        borderRadius: "12px",
                        background: isGroupActive
                          ? "#aeffc5"
                          : "#ffc8c3",
                        color: isGroupActive
                          ? "#1e7e34"
                          : "#b02a37",
                        fontWeight: 500,
                      }}
                    >
                      {hasGroupSchedule
                        ? isGroupActive
                          ? "In Schedule"
                          : "Out Of Schedule"
                        : "No Schedule"}
                    </div>
                    <FiLogOut
                      size={16}
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      title="Exit Group"
                      onClick={() => handleExitClick(grp)}
                    />
                    </div>
                  </div>

                  {/* Group Section */}
                  <div
                    style={{
                      padding: "8px",
                      borderRadius: "6px",
                      border: "1px dashed #ddd",
                      marginBottom: "6px",
                    }}
                  >
                    <div
                      className="stat-value"
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        marginBottom: 2,
                      }}
                    >
                      🧩 Group Schedule
                    </div>
                    <div
                      className="stat-value"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {hasGroupSchedule
                        ? `${formatTime(grp.group_schedule.start_time)} - ${formatTime(grp.group_schedule.end_time)}`
                        : "Not Assigned"}
                    </div>

                    <div
                      className="stat-value"
                      style={{ fontSize: "0.7rem" }}
                    >
                      {hasGroupSchedule
                        ? grp.group_schedule.week_days?.join(", ")
                        : ""}
                    </div>
                  </div>

                  {/* Agent Section */}
                  <div
                    style={{
                      padding: "8px",
                      borderRadius: "6px",
                      border: "1px dashed #ddd",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="stat-value"
                        style={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                        }}
                      >
                        👤 Agent Schedule
                      </div>

                      <div
                        style={{
                          padding: "2px 6px",
                          borderRadius: "12px",
                          background: isAgentActive
                            ? "#a6fbbe"
                            : "#f5b9b2",
                          fontWeight: 500,
                          fontSize: "0.65rem",
                          color: !hasAgentSchedule
                            ? "#999"
                            : isAgentActive
                            ? "#1e7e34"
                            : "#dc3545",
                        }}
                      >
                        {!hasAgentSchedule
                          ? "Not Assigned"
                          : isAgentActive
                          ? "In Schedule"
                          : "Out Of Schedule"}
                      </div>
                    </div>

                    <div
                      className="stat-value"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {hasAgentSchedule
                        ? `${formatTime(grp.schedule.start_time)} - ${formatTime(grp.schedule.end_time)}`
                        : "-"}
                    </div>

                    <div
                      className="stat-value"
                      style={{ fontSize: "0.7rem" }}
                    >
                      {hasAgentSchedule
                        ? grp.schedule.week_days?.join(", ")
                        : ""}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {(Object.keys(agentSchedule).length > 0) && (
            <div className="panel">
              <div className="panel-header">
                <span className="panel-title">Inbound Calling Agent Schedule</span>
              </div>

              <div
                className="panel-body tiny-pad"
                style={{ height: "240px", maxHeight: "240px" }}
              >
                {(() => {
                  if (!agentSchedule) return false;
                  const isActive = isInSchedule(agentSchedule);

                  return (
                    <div
                      style={{
                        padding: "12px",
                        borderRadius: "10px",
                        border: "1px solid #eee",
                      }}
                    >
                      {/* Status */}
                      <div
                        style={{
                          marginBottom: "10px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          background: isActive ? "#a6fbbe" : "#f5b9b2",
                          color: isActive ? "#1e7e34" : "#dc3545",
                        }}
                      >
                        {isActive ? "In Schedule" : "Out Of Schedule"}
                      </div>

                      {/* Time */}
                      <div
                        className="stat-value"
                        style={{ fontSize: "0.85rem", marginBottom: "6px" }}
                      >
                        ⏰ {formatTime(agentSchedule?.start_time)} - {formatTime(agentSchedule?.end_time)}
                      </div>

                      {/* Week Days */}
                      <div
                        className="stat-value"
                        style={{ fontSize: "0.75rem", color: "#bbb" }}
                      >
                        📅 {agentSchedule?.week_days?.join(", ")}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          )}


          <div className="panel">
            <div className="panel-header">
              <span className="panel-title">Announcements</span>
            </div>
            <div
              className="panel-body tiny-pad"
              style={{ height: "240px", overflowY: "hidden", maxHeight: "240px" }}
            >
              {formattedAnnouncements.length ? (
                formattedAnnouncements.map((a, idx) => (
                  <div
                    key={a.id || idx}
                    className={`announce-card ${idx % 2 === 0 ? "amber-bg" : "blue-bg"}`}
                  >
                    <div className="d-flex align-center" style={{ justifyContent: "space-between" }}>
                      <div className="announce-tag amber-text">{a.heading}</div>
                      {!!a.createdAt && (
                        <div className="micro-meta" style={{ fontSize: "10px" }}>{formatAnnouncementDate(a.createdAt)}</div>
                      )}
                      </div>
                    <div className="announce-copy">{a.content}</div>
                  </div>
                ))
              ) : (
                <div className="announce-card blue-bg">
                  <div className="announce-tag amber-text">No Announcements</div>
                  <div className="announce-copy">
                    You have no announcements right now.
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="panel fill-panel">
            <div className="panel-header">
              <span className="panel-title">Today's Performance</span>
            </div>
            <div className="panel-body perf-body">
              {performanceBlocks.map((item) => (
                <div className="perf-block" key={item.label}>
                  <div className="perf-row">
                    <span>{item.label}</span>
                    <span style={{ color: item.color }}>{item.value}</span>
                  </div>
                  <div className="prog-track">
                    <div
                      className="prog-fill"
                      style={{ width: item.width, background: item.color }}
                    />
                  </div>
                </div>
              ))}
              {/* <div className="leaderboard-box">
                <div className="leaderboard-label">Leaderboard Rank</div>
                <div className="leaderboard-rank">#1</div>
                <div className="leaderboard-sub">of {Number(agentCallsData?.agentsData?.length) || 1} agents today</div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="stack-col" style = {{marginLeft : '5px'}}>
          <div className="panel shrink-panel">
            <div className="panel-header">
              <span className="panel-title">WEBRTC Dialer</span>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <span
                  className={`status-pill ${
                    !parsedStatus || !parsedStatus?.success ? "away" : ""
                  }`}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    color: parsedStatus?.success
                      ? theme === "dark"
                        ? "#4ade80"
                        : "green"
                      : theme === "dark"
                      ? "#f87171"  
                      : "red",
                  }}
                >
                  <FiInfo size={12} />

                  {parsedStatus?.success ? (
                    <FaCheck size={12} />
                  ) : (
                    <FaTimes size={12} />
                  )}
                  {parsedStatus?.success ? "READY" : parsedStatus?.code ?? "DISCONNECTED"}
                </span>
              </OverlayTrigger>
            </div>
            <div className="panel-body tight-body">
              <div className="dialer-input-wrap">
                <Form.Control
                  className="dialer-input"
                  style={{ fontSize: "13px" }}
                  value={dialNum}
                  placeholder="+91 · · · · · · · · · ·"
                  readOnly
                  id="numberToCall"
                />
                <button
                  type="button"
                  className="dial-clear"
                  onClick={onDialBack}
                >
                  <DeleteGlyph />
                </button>
              </div>
              <div className="dialpad">
                {dialKeys.map(([num, sub]) => (
                  <button
                    key={num}
                    type="button"
                    className="dial-key keypad"
                    id="keypad"
                    style={{ cursor: (!parsedStatus?.success) ? "not-allowed" : "pointer", opacity: (!parsedStatus?.success) ? 0.5 : 1 }}
                    disabled={!parsedStatus?.success}
                    onClick={() => {
                      playTone(num);
                      onDial(num);
                    }}
                  >
                    <span className="dial-key-num">{num}</span>
                    <span className="dial-key-sub">{sub || "\u00A0"}</span>
                  </button>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  onClick={
                    isOnCall
                      ? () => {
                          
                        }
                      : dialNum && parsedStatus?.success
                      ? handleDialerCall
                      : undefined
                  }
                  className={isOnCall ? "call hangup" : "call answer"}
                  id={`${isOnCall || parsedStatus?.success ? "hangupButtonOnIdleScreen" : "callButtonOnIdleScreen"}`}
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background:
                      isOnCall
                        ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                        : dialNum && parsedStatus?.success
                        ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                        : "#9ca3af",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor:
                      isOnCall || (dialNum && parsedStatus?.success)
                        ? "pointer"
                        : "not-allowed",
                    boxShadow:
                      isOnCall
                        ? "0 6px 20px rgba(239, 68, 68, 0.35), 0 0 0 4px rgba(239, 68, 68, 0.1)"
                        : dialNum && parsedStatus?.success
                        ? "0 6px 20px rgba(16, 185, 129, 0.4), 0 0 0 4px rgba(16, 185, 129, 0.1)"
                        : "none",
                    transition: "all 0.3s ease",
                    border: "none",
                    opacity: isOnCall || (dialNum && parsedStatus?.success) ? 1 : 0.6,
                    pointerEvents:
                      isOnCall || (dialNum && parsedStatus?.success) ? "auto" : "none",
                  }}
                  onMouseEnter={(e) => {
                    if (!(isOnCall || (dialNum && parsedStatus?.success))) return;
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow =
                      isOnCall
                        ? "0 8px 24px rgba(239, 68, 68, 0.45), 0 0 0 6px rgba(239, 68, 68, 0.15)"
                        : "0 8px 24px rgba(16, 185, 129, 0.5), 0 0 0 6px rgba(16, 185, 129, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    if (!(isOnCall || (dialNum && parsedStatus?.success))) return;
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      isOnCall
                        ? "0 6px 20px rgba(239, 68, 68, 0.35), 0 0 0 4px rgba(239, 68, 68, 0.1)"
                        : "0 6px 20px rgba(16, 185, 129, 0.4), 0 0 0 4px rgba(16, 185, 129, 0.1)";
                  }}
                >
                  {isOnCall ? (
                    <FiPhoneOff style={{ fontSize: "18px", color: "white" }} />
                  ) : (
                    <FiPhoneCall style={{ fontSize: "18px", color: "white" }} />
                  )}
                </div>
              </div>
              {/* <Button className="dial-call-btn" onClick={onPlaceCall}>
                <FiPhoneCall />
                PLACE CALL
              </Button> */}
            </div>
          </div>

          <div className="panel fill-panel" style={{ height: "300px", maxHeight: "300px", overflowY: "scroll" }}>
            <div className="tab-bar" style={{ justifyContent: "space-between" }}>
              {[
                ["log", "Call Log"],
                ["contacts", "Agent Phonebook"],
              ].map(([key, label]) => (
                <button
                  key={key}
                  type="button"
                  className={`tab ${activeTab === key ? "active" : ""}`}
                  onClick={() => onTabChange(key)}
                >
                  {label}
                </button>
              ))}
            </div>
            <div
              className={`tab-content ${activeTab === "log" ? "active" : ""}`}
            >
              {/* Date filters */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "6px 8px",
                  borderBottom: "1px solid rgba(0,0,0,0.07)",
                  background: "var(--surface, #f9fafb)",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <label style={{ fontSize: 9, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>
                    From
                  </label>
                  <input
                    type="date"
                    value={callLogStartDate}
                    min={callLogMinDate}
                    max={callLogEndDate}
                    onChange={handleCallLogStartDate}
                    style={{
                      fontSize: 11,
                      border: "1px solid #e5e7eb",
                      borderRadius: 6,
                      padding: "3px 6px",
                      outline: "none",
                      background: "white",
                      color: "inherit",
                      width: "100%",
                    }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <label style={{ fontSize: 9, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>
                    To
                  </label>
                  <input
                    type="date"
                    value={callLogEndDate}
                    min={callLogStartDate}
                    max={callLogMaxDate}
                    onChange={handleCallLogEndDate}
                    style={{
                      fontSize: 11,
                      border: "1px solid #e5e7eb",
                      borderRadius: 6,
                      padding: "3px 6px",
                      outline: "none",
                      background: "white",
                      color: "inherit",
                      width: "100%",
                    }}
                  />
                </div>
              </div>

              {/* Log list */}
              <div>
              {formattedCallLogs.length === 0 ? (
                <div
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "13px",
                  }}
                >
                  No call records found
                </div>
              ) : (
                formattedCallLogs.map((item) => (
                  <div className="log-item" key={item.id}>
                    <div className="log-icon" style={{ color: item.color }}>
                      {item.icon}
                    </div>
                    <div className="flex-1">
                      <div className="log-name">{item.name}</div>
                      <div className="log-num">{item.num}</div>
                    </div>
                    <div className="text-right">
                      <div
                        className="log-dur"
                        style={item.danger ? { color: "var(--red)" } : undefined}
                      >
                        {item.dur}
                      </div>
                      <div className="log-time">{item.time}</div>
                    </div>
                  </div>
                ))
              )}
              </div>
            </div>
            <div
              className={`tab-content ${activeTab === "contacts" ? "active" : ""}`}
            >
              <div className="search-wrap">
                <FiSearch className="search-icon" />
                <input
                  className="search-bar"
                  placeholder="Search name or number..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              {filteredAgents?.length === 0 ? (
                  <div style={{ padding: "10px", textAlign: "center", color: "#9ca3af", fontSize: "13px" }}>
                    No agents found
                  </div>
                ) : (
                  filteredAgents?.map((item) => {
                    const agent = item.agent;
                    const isActive = item.status === "active";

                    return (
                      <div className="contact-item" key={agent.id}>
                        <div
                          className="cti-avatar"
                          style={{
                            ...toneStyle("blue"),
                            position: "relative",
                          }}
                        >
                          {agent.agent_name?.[0]}

                          <span
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              background: isActive ? "#22c55e" : "#ef4444",
                              // border: "2px solid white",
                            }}
                          />
                        </div>

                        <div className="flex-1">
                          <div className="contact-name">{agent.agent_name}</div>
                          <div className="contact-num">{agent.agent_number}</div>
                        </div>

                        <Button
                          className="call-mini-btn"
                          disabled={!isActive || !parsedStatus?.success}
                          style={{
                            background: isActive && parsedStatus?.success ? "#10b981" : "#9ca3af",
                            border: "none",
                            cursor: isActive && parsedStatus?.success ? "pointer" : "not-allowed",
                            opacity: isActive && parsedStatus?.success ? 1 : 0.6,
                          }}
                          onClick={() => {
                            if (isActive && parsedStatus?.success) {
                              handleAgentCall(agent.agent_number);
                            }
                          }}
                        >
                          CALL
                        </Button>
                      </div>
                    );
                  })
                )}
            </div>
            {/* <div
              className={`tab-content ${activeTab === "schedule" ? "active" : ""}`}
            >
              {callbacks.map((item) => (
                <div className="log-item" key={item.name}>
                  <div className="log-icon" style={{ color: item.color }}>
                    {item.icon}
                  </div>
                  <div className="flex-1">
                    <div className="log-name">{item.name}</div>
                    <div className="log-num">{item.due}</div>
                  </div>
                  <Button className="call-mini-btn slim-mini-btn">CALL</Button>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
    <Modal
      show={showExitModal}
      onHide={() => setShowExitModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Exit Call Group</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Are you sure you want to exit this call group?
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowExitModal(false)}
        >
          Cancel
        </Button>

        <Button
          variant="danger"
          onClick={handleConfirmExit}
          disabled={removeGroupLoading}
          style={{ opacity: removeGroupLoading ? 0.6 : 1, cursor: removeGroupLoading ? "not-allowed" : "pointer" }}
        >
          Confirm Exit
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
}

export default React.memo(IdleScreen);
